import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { EmployerGroupComponent } from './employer-group.component';
import { EmployerInfoModule } from '../../controls/employer-info/employer-info.module';
import { AddressInfoModule } from '../../controls/address-info/address-info.module';
import { ContactInfoModule } from '../../controls/contact-info/contact-info.module';
import { EmployerPaymentInfoModule } from '../../controls/employer-payment-info/employer-payment-info.module';
import { OtherIncomesInfoModule } from '../../controls/other-incomes-info/other-incomes-info.module';

@NgModule({
  declarations: [EmployerGroupComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EmployerInfoModule,
    AddressInfoModule,
    ContactInfoModule,
    EmployerPaymentInfoModule,
    OtherIncomesInfoModule,
  ],
  exports: [EmployerGroupComponent],
})
export class EmployerGroupModule {}
